<p class="text-muted mb-15" style="font-size: 13px;">
  El Flow de Logo (LOGO_TOKEN) depende de un programa: las 3 preguntas que se le hacen al usuario
  salen de la configuración de ese programa. Elige uno para probar la generación.
</p>

<div class="row mb-15">
  <div class="col-lg-6 col-md-8 col-sm-12">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Programa (con generación de logos activa)</mat-label>
      <mat-select [(ngModel)]="selectedProgramId" (selectionChange)="onProgramChange()">
        <mat-option value="" disabled>Selecciona un programa</mat-option>
        <mat-option *ngFor="let p of programs" [value]="p.id">
          {{ p.program_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div *ngIf="loading" class="text-muted">Cargando programas…</div>
<div *ngIf="errorMessage" class="alert-message error-message">{{ errorMessage }}</div>
<div *ngIf="!loading && programs.length === 0" class="no-results">
  No hay programas con "Generación de Logos con IA" activada. Actívala en
  Programas → Crear/Editar → sección "Generación de Logos con IA".
</div>

<app-logo-tester
  *ngIf="selectedProgramId"
  [programId]="selectedProgramId"
></app-logo-tester>
